// @ts-nocheck
import React, { createContext, useContext, useMemo, useState } from 'react';
import { createTheme, ThemeProvider as MUIThemeProvider, useTheme } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import Brightness7Icon from '@mui/icons-material/Brightness7'; // light mode icon
import Brightness4Icon from '@mui/icons-material/Brightness4'; // dark mode icon
import { lightTheme, darkTheme } from './themeConfig'

const ThemeContext = createContext({
  toggleColorMode: () => {}
});

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState<'light' | 'dark'>(localStorage.getItem('themeMode') === 'dark' ? 'dark' : 'light');

  // Effect to apply fixed classes or styles when the theme changes
  React.useEffect(() => {
    const currentMode = mode;
    localStorage.setItem('themeMode', currentMode);
    document.body.className = currentMode;
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  const theme = useMemo(() => (mode === 'light' ? lightTheme : darkTheme), [mode]);

  return (
    <ThemeContext.Provider value={colorMode}>
      <MUIThemeProvider theme={theme}>
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useColorMode = () => useContext(ThemeContext);

export const ColorModeToggleButton = () => {
  const theme = useTheme();
  const colorMode = useColorMode();

  return (
    <IconButton sx={{ ml: 1 }} onClick={colorMode.toggleColorMode} color="inherit">
      {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );
};

export const useThemeContext = () => useContext(ThemeContext);